import React from "react";
import { shade } from "polished";
import styled, { css } from "styled-components";
import { Box, Flex } from "rebass";

const Wrapper = styled(Box)``;

Wrapper.defaultProps = {
  is: "section",
  bg: "grey.2",
};

const Container = styled(Flex)`
  align-items: flex-start;
  flex-direction: row;
  max-width: 90rem;

  ${(props) =>
    props.skinny &&
    css`
      max-width: 60rem;
    `};

  ${(props) =>
    props.column &&
    css`
      flex-direction: column;
    `};

  @media only screen and (max-width: 64em) {
    flex-direction: column;
  }
`;

Container.defaultProps = {
  mx: "auto",
  px: [4, 5, 6, 8],
  py: [4, 4, 4, 5],
};

const BorderTop = styled(Box)`
  display: none;
  width: 100%;
  height: 1px;
  margin-top: -48px;
  padding-bottom: 48px;
  border-top: 1px solid
    ${(props) =>
      props.theme.colors.grey[1] && shade(0.875, props.theme.colors.grey[1])};
  ${(props) =>
    props.borderTop &&
    css`
      display: block;
    `};
`;

const PageSection = (props) => (
  <Wrapper className={props.className} style={props.style}>
    <Container skinny={props.skinny} column={props.column}>
      <BorderTop borderTop={props.borderTop} />
      {props.children}
    </Container>
  </Wrapper>
);

export default PageSection;



// WEBPACK FOOTER //
// ./src/components/PageSection.js